<template>
  <div class="modal light" :class="{ 'is-active': isActive }">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t('modals.slip.title') }}</p>
        <button class="delete" aria-label="close" @click="closeModal"></button>
      </header>
      <section class="modal-card-body">
        <div class="check-balance" @click="getSlip">
          <i class="fas fa-sync-alt m-r-5"></i>
          <span>{{ $t('modals.slip.currentStatusTxt') }}</span>
        </div>
        <b-table
          class="m-t-20"
          :data="userSlip"
          :paginated="isPaginated"
          :per-page="perPage"
          :current-page="current"
          :pagination-simple="isPaginationSimple"
          :pagination-position="paginationPosition"
          :range-before="3"
          :range-after="1"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
        >
          <b-table-column
            field="receiveAt"
            :label="$t('modals.receiveAtLabel')"
            width="100px"
            v-slot="props"
          >
            {{ props.row.createdAt | datetimeFormat }}
          </b-table-column>
          <b-table-column
            field="amountLabel"
            :label="$t('modals.amountLabel')"
            width="130px"
            numeric
            v-slot="props"
          >
            <div v-if="props.row.amount > 0">
              <span>{{ props.row.amount | numberFormat }}</span>
            </div>
            <div v-else><span>-</span></div>
          </b-table-column>
          <b-table-column
            field="statusLabel"
            :label="$t('modals.slip.statusLabel')"
            v-slot="props"
          >
            <div
              v-html="
                `${status(props.row.status)}<br>${reason(props.row.note)}`
              "
            ></div>
          </b-table-column>
          <b-table-column
            field="imgLabel"
            :label="$t('modals.slip.imgLabel')"
            width="80px"
            v-slot="props"
          >
            <span class="view-reference" @click="viewReference(props.row)">{{
              $t('modals.slip.selectView')
            }}</span>
          </b-table-column>
        </b-table>
      </section>
    </div>
  </div>
</template>

<script>
import apiStatement from '@/api/statement'
import i18n from '@/language'
export default {
  name: 'ModalSlip',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      userSlip: [],
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: 'bottom',
      current: 1,
      perPage: 10
    }
  },
  mounted() {
    this.getSlip()
  },
  methods: {
    closeModal() {
      this.$emit('closeModal', null)
    },
    async getSlip() {
      let loading = this.$loading.show()

      setTimeout(async () => {
        try {
          const data = await apiStatement.getSlip(this.current, this.perPage)
          this.userSlip = data.slips

          loading.hide()
        } catch {
          loading.hide()
        }
      }, 200)
    },
    status(status) {
      let style = 'has-text-warning'
      let icon = 'fa-info-circle'
      let text = i18n.t('modals.slip.inProgressMsg')

      if (status === 'SUCCESS') {
        style = 'has-text-success'
        icon = 'fa-check-circle'
        text = i18n.t('modals.slip.successMsg')
      } else if (status === 'FAILED') {
        style = 'has-text-danger'
        icon = 'fa-times-circle'
        text = i18n.t('modals.slip.failMsg')
      }

      return `<span class="${style} m-l-5"><i class="fas ${icon}"></i> ${text}</span>`
    },
    reason(note) {
      let message = ''
      switch (note) {
        // case 'UPLOADED_FILE_NOT_EXIST':
        //   message = 'หาไฟล์รูป slip ไม่เจอ'

        //   break
        // case 'IMG_SIZE_UNABLE_TO_PROCESS':
        //   message = 'รูป resize ไม่ได้'

        //   break
        // case 'CANNOT_READ_CROPPED_IMAGE':
        //   message = 'รูป crop ไม่ได้'

        //   break
        case 'UPLOADED_FILE_NOT_EXIST':
        case 'IMG_SIZE_UNABLE_TO_PROCESS':
        case 'CANNOT_READ_CROPPED_IMAGE':
          message = i18n.t('modals.slip.incorrectSlipMsg')

          break

        case 'DEST_ACC_INVALID':
          message = i18n.t('modals.slip.destAccInvalidMsg')

          break
        case 'SLIP_REFNO_DUPLICATED':
          message = i18n.t('modals.slip.duplicateSlipMsg')

          break
        case 'UNSTABLE_REFNO_ON_SLIP':
          message = i18n.t('modals.slip.unstableRefNoMsg')

          break
        case 'TRIPPLE_WRONG_CAPTCHA':
          message = i18n.t('modals.slip.wrongCaptchaMsg')

          break
        case 'INVALID_SLIP':
          message = i18n.t('modals.slip.invalidSlipMsg')

          break
        case 'NOT_MATCH':
          message = i18n.t('modals.slip.notMatchMsg')

          break
        case 'EXPIRED_SLIP':
          message = i18n.t('modals.slip.expiredSlipMsg')

          break
        case 'UNKNOW_ERROR':
          message = i18n.t('modals.slip.unknownErrorMsg')

          break
        // case 'MATCH_ONE':
        //   message = ''

        //   break
      }

      return message ? `(${message})` : ''
    },
    viewReference(row) {
      const win = window.open('about:blank')

      if (row.link) {
        win.location = row.link
      } else {
        apiStatement.getSlipRef(row.reference).then(data => {
          win.location = data.url
        })
      }
    }
  }
}
</script>
<style scoped lang="scss">
.check-balance {
  font-size: 18px;
  // margin-left: 10px;
  font-weight: bold;

  span {
    margin-left: 5px;
    text-decoration: underline;
  }

  &:hover {
    cursor: pointer;
  }
}

.view-reference {
  cursor: pointer;
  text-decoration: underline;
}
</style>
